"use client";

import { magicLinkClient, organizationClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";

export const auth = createAuthClient({
	plugins: [
		magicLinkClient(),
		organizationClient(),
	]
});

export const { signIn, signOut } = auth;
